var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-simple-checkbox',{attrs:{"color":"primary","indeterminate":_vm.internalIndeterminate,"ripple":false},model:{value:(_vm.internalCheck),callback:function ($$v) {_vm.internalCheck=$$v},expression:"internalCheck"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }